export const ROLE_PREFIX = 'ROLE_';

export const MAX_ROLE_NAME_LENGTH = 80;

export const MAX_SUFFIX_LENGTH = MAX_ROLE_NAME_LENGTH - ROLE_PREFIX.length;

export const INITIAL_STATE = {
  roleSuffix: '',
  description: '',
  descriptionTouched: false,
  creating: false,
};

export const formatSuffix = (value) =>
  value
    .toUpperCase()
    .replace(/[^A-Z0-9_\s]/g, '')
    .replace(/[\s_]+/g, '_')
    .replace(/^_+/, '')
    .replace(/^ROLE_/, '')
    .slice(0, MAX_SUFFIX_LENGTH);

export const validateSuffix = (suffix) => {
  if (!suffix) return 'Role name is required.';
  if (!/^[A-Z0-9_]+$/.test(suffix)) {
    return 'Use only uppercase letters, numbers and underscores.';
  }
  if (!/[A-Z0-9]/.test(suffix)) {
    return 'Role name must contain at least one letter or number.';
  }
  return '';
};


